import {useTranslation} from "react-i18next";

import React, {useMemo, useState} from 'react'
import {
    HideColumnIdsExportParams,
    HideRowsIdsExportParams,
    IExportParamsContext,
    IExportParamsSettings
} from "@containers/export/containers/buildData/hooks/types/exportParams";

export const DEFAULT_EXPORT_SINGLE_SETTINGS: IExportParamsSettings = {
    ignoredExportColumnKey: null,
    exportFromAllColumns: false,
    rootDataSetPosition: 1,
    rootYSteps: 0,
}

export interface IProps {
    initialAdditionalDataSet?: any,
    initialExportDataFromAllPage?: boolean,
    initialFileName?: string,
    settings?: IExportParamsSettings,
}

export function useExportParams<T>({
                                       initialAdditionalDataSet,
                                       initialExportDataFromAllPage,
                                       initialFileName,
                                       settings = DEFAULT_EXPORT_SINGLE_SETTINGS,
                                   }: IProps = {}): IExportParamsContext<T> {

    const {t} = useTranslation()
    const [additionalDataSet, setAdditionalDataSet] = React.useState(initialAdditionalDataSet)
    const [hideRowIds, setHideRowIds] = useState<HideRowsIdsExportParams>({} as HideRowsIdsExportParams)
    const [hideColumnIds, setHideColumnIds] = useState<HideColumnIdsExportParams<T>>({} as HideColumnIdsExportParams<T>)

    const [exportMode, setExportMode] = React.useState(false);
    const [fileName, setFileName] = React.useState(initialFileName ?? t('base.tableFileName'))
    const [exportDataFromAllPage, setExportDataFromAllPage] = React.useState(initialExportDataFromAllPage ?? false)

    const currentSettings = useMemo(() => {
        return settings ? {
            ...DEFAULT_EXPORT_SINGLE_SETTINGS,
            ...settings,
        } : DEFAULT_EXPORT_SINGLE_SETTINGS
    }, [settings])


    return {
        exportMode, setExportMode,
        additionalDataSet, setAdditionalDataSet,
        fileName, setFileName,
        exportDataFromAllPage, setExportDataFromAllPage,
        settings: currentSettings,
        hideRowIds, setHideRowIds,
        hideColumnIds, setHideColumnIds,
    }

}


